import { render, staticRenderFns } from "./DetalleCapacitacion.vue?vue&type=template&id=6099f5d8&scoped=true"
import script from "./DetalleCapacitacion.vue?vue&type=script&lang=js"
export * from "./DetalleCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./DetalleCapacitacion.vue?vue&type=style&index=0&id=6099f5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6099f5d8",
  null
  
)

export default component.exports